import { IDocument, IFolder } from 'interfaces';
import { documnentIcons, getCorrectIcon } from 'helpers/documentIcons';
import { TFunction } from 'i18next';

export const renderSelectedEntities = (
  choosenDocuments: any[],
  documents: IDocument[],
  folders: IFolder[],
  t: TFunction
) => {
  const choosenFiles = choosenDocuments.filter(({ key }) => !(key as string).startsWith('folder'));
  const choosenFolders = choosenDocuments.filter(({ key }) => (key as string).startsWith('folder'));

  const namesOfChoosenFiles = choosenFiles.map(({ key }) => {
    const currentDocName = documents.find((doc) => doc.id === (key as string).split(' ')[2]);      
    const versionsCnt = currentDocName?.version_count && currentDocName?.version_count > 1
      ? `(+${currentDocName?.version_count - 1} ${t('Documents.management.versionsCnt')})` : ''
    return (
      <div key={key}>
        <span>{documnentIcons[getCorrectIcon(currentDocName?.extension || 'default')]}</span> {currentDocName?.name + versionsCnt}
      </div>
    );
  });

  const namesOfChoosenFolders = choosenFolders.map(({ key }) => {
    return (
      <div key={key}>
        <span>{documnentIcons[getCorrectIcon('folder')]}</span> {folders.find((folder) => folder.id === (key as string).split(' ')[1])?.name}
      </div>
    );
  });

  return { namesOfChoosenFiles, namesOfChoosenFolders };
};
